/* «Pruébatelo» · probador con IA (5-oct-2026: colgantes de patitos de una figura)
   La clienta hace o elige un selfie; se reduce a 1024 px en el móvil y va al servidor cstmm-ia por el App Proxy
   (/apps/ia/probar, dos pasos: nº de encargo y luego /estado). Vuelve la misma foto con la joya puesta a su tamaño real.
   La foto no se guarda en ningún sitio. */
(function () {
  'use strict';
  var API = '/apps/ia';
  var raiz = document.querySelector('[data-cm-probador]');
  if (!raiz || raiz.dataset.listo) return;
  raiz.dataset.listo = '1';
  var pieza = raiz.dataset.pieza || 'mama-pata';
  var mm = raiz.dataset.mm || '14';               // lado de la pieza sin anilla, para los textos
  // Modo de la pieza (collares de oro, 5-oct): «nombre» o «inicial» (la IA escribe el de la clienta), «ejemplo» (los
  // nombres o grabados de la foto son de muestra) o «simple». Los patitos no lo llevan.
  var modo = raiz.dataset.modo || (raiz.dataset.nombre === '1' ? 'nombre' : 'simple');
  var conNombre = modo === 'nombre' || modo === 'inicial' || modo === 'anillo-nombre';
  var esInicial = modo === 'inicial';
  var esTextos = modo === 'textos';                // varios nombres/textos de la clienta (6-oct): los campos de la ficha
  var esAnillo = /^anillo/.test(modo);             // alianzas y anillos: foto de la mano, el anillo en el anular
  var esAlianza = modo === 'anillo';               // solo las alianzas: «la alianza» y la mano de la pareja
  var laPieza = esAlianza ? 'la alianza' : 'el anillo';
  var previos = [];                                // alianzas: la foto anterior (la de la pareja) se enseña junto a la nueva
  var medida = raiz.dataset.medida || (mm + ' mm');

  // El botón, dentro de la galería principal (la de la ficha, no la de la compra rápida), debajo de las fotos: fuera de
  // ella, la cuadrícula de Prestige lo manda al final de la ficha en el móvil.
  // En escritorio la galería enseña todas las fotos en columna (el botón quedaría a 1.700 px): allí va en la columna de
  // la compra, justo antes del paso 1.
  var galeria = document.querySelector('product-gallery[form^="product-form-main"]') || document.querySelector('product-gallery');
  var escritorio = window.matchMedia('(min-width: 1000px)');
  function colocar() {
    var paso1 = document.querySelector('[data-cm-step="1"]');
    var bloque = (paso1 && paso1.closest('.product-info__block-item')) ||   // fichas sin pasos: antes del campo de grabado
      document.querySelector('.product-info .product-info__block-item[data-block-type="line-item-property"]');
    if (escritorio.matches && bloque) bloque.insertAdjacentElement('beforebegin', raiz);
    else if (galeria) galeria.appendChild(raiz);
  }
  colocar();
  if (escritorio.addEventListener) escritorio.addEventListener('change', colocar);
  raiz.hidden = false;

  function sesionId() {
    try {
      var k = localStorage.getItem('cm-ia-sesion');
      if (!k) { k = Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem('cm-ia-sesion', k); }
      return k;
    } catch (e) { return 'anon' + Math.random().toString(36).slice(2); }
  }
  // Medición del piloto (28 días): eventos para los píxeles de Shopify y GTM, y una marca oculta en la cesta
  // («_probador», no se ve en el checkout) para comparar la conversión de quien se lo ha probado.
  function evento(nombre, datos) {
    datos = Object.assign({ pieza: pieza }, datos || {});
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('cm_probador_' + nombre, datos); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'cm_probador_' + nombre }, datos)); } catch (e) {}
  }
  function marcarCesta() {
    try {
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { _probador: pieza } }) }).catch(function () {});
    } catch (e) {}
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  // La hoja (en body, para que no la recorte ningún contenedor del tema)
  var hoja = document.createElement('div');
  hoja.className = 'cm-pr-hoja';
  hoja.hidden = true;
  hoja.setAttribute('role', 'dialog');
  hoja.setAttribute('aria-modal', 'true');
  hoja.setAttribute('aria-label', 'Pruébatelo');
  hoja.innerHTML =
    '<div class="cm-pr-hoja__fondo" data-cerrar></div>' +
    '<div class="cm-pr-hoja__caja">' +
      '<button type="button" class="cm-pr-hoja__x" data-cerrar aria-label="Cerrar">×</button>' +
      '<div class="cm-pr-hoja__cuerpo" data-cuerpo></div>' +
    '</div>' +
    '<input type="file" accept="image/*" capture="user" hidden data-camara>' +
    '<input type="file" accept="image/*" hidden data-galeria>';
  document.body.appendChild(hoja);
  var cuerpo = hoja.querySelector('[data-cuerpo]');
  if (esAnillo) hoja.querySelector('[data-camara]').setAttribute('capture', 'environment');   // la mano: cámara trasera
  var inCamara = hoja.querySelector('[data-camara]'), inGaleria = hoja.querySelector('[data-galeria]');
  var quedan = null, resultado = null, encargoVivo = 0;

  function abrir() {
    hoja.hidden = false;
    document.documentElement.classList.add('cm-pr-abierta');
    evento('abrir');
    if (!resultado) pintarInicio();
    requestAnimationFrame(function () { hoja.classList.add('is-abierta'); });
  }
  function cerrar() {
    hoja.classList.remove('is-abierta');
    document.documentElement.classList.remove('cm-pr-abierta');
    setTimeout(function () { hoja.hidden = true; }, 220);
    if (resultado) marcarListo();
  }
  function marcarListo() {
    raiz.classList.add('is-listo');
    raiz.querySelector('.cm-pr__textos span').textContent = 'Tu foto está lista: toca para verla';
  }
  raiz.querySelector('[data-cm-pr-abrir]').addEventListener('click', abrir);
  hoja.addEventListener('click', function (e) {
    if (e.target.closest('[data-cerrar]')) return cerrar();
    if ((e.target.closest('[data-camara-btn]') || e.target.closest('[data-galeria-btn]')) && conNombre) {
      var campo = cuerpo.querySelector('[data-nombre-campo]');
      if (campo && !campo.value.trim()) { campo.focus(); campo.classList.add('is-error'); return; }
    }
    if (e.target.closest('[data-camara-btn]')) return inCamara.click();
    if (e.target.closest('[data-galeria-btn]')) return inGaleria.click();
    if (e.target.closest('[data-otra]')) { if (esAlianza && resultado) previos = [resultado]; resultado = null; return pintarInicio(); }
    if (e.target.closest('[data-personalizar]')) return irAPersonalizar();
    if (e.target.closest('[data-compartir]')) return compartir();
    var z = e.target.closest('[data-zoom]');
    if (z) return ampliar(z);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !hoja.hidden) cerrar(); });
  [inCamara, inGaleria].forEach(function (inp) {
    inp.addEventListener('change', function () {
      var f = inp.files && inp.files[0];
      inp.value = '';
      if (f) procesar(f);
    });
  });

  function pintarInicio(error) {
    cuerpo.innerHTML =
      '<p class="cm-pr-hoja__etiqueta">Pruébatelo</p>' +
      (esAnillo
        ? '<h2 class="cm-pr-hoja__titulo">' + (previos.length ? 'Ahora, la mano de tu pareja' : 'Mira cómo te queda ' + laPieza) + '</h2>' +
          '<p class="cm-pr-hoja__texto">Haz una foto del dorso de tu mano y te ponemos ' + laPieza + ' en el anular, a su tamaño real (' + esc(medida) + ').</p>'
        : '<h2 class="cm-pr-hoja__titulo">Mira cómo te queda antes de pedirlo</h2>' +
          '<p class="cm-pr-hoja__texto">Haz un selfie con el cuello a la vista y te lo enseñamos puesto, a su tamaño real (' + esc(medida) + ').</p>') +
      (conNombre ? '<label class="cm-pr-hoja__campo"><span>' + (esInicial ? 'Tu inicial' : 'Nombre de la joya') + '</span>' +
        '<input type="text" maxlength="' + (esInicial ? 1 : 14) + '" autocomplete="off" data-nombre-campo value="' +
        esc(esInicial ? nombreFicha().slice(0, 1) : nombreFicha()) + '" placeholder="' + (esInicial ? 'A' : 'Escribe el nombre') + '"></label>' : '') +
      (esTextos ? camposFicha().map(function (c) {
        return '<label class="cm-pr-hoja__campo"><span>' + esc(c.etiqueta) + '</span><input type="text" maxlength="' + (c.max || 24) + '" autocomplete="off" ' +
          'data-texto-campo data-de="' + esc(c.de) + '" value="' + esc(c.a) + '" placeholder="' + esc(c.de || 'Escribe el texto') + '"></label>';
      }).join('') : '') +
      (esAnillo
        ? '<ul class="cm-pr-hoja__consejos"><li>El dorso de la mano, de frente</li><li>Los dedos un poco separados</li><li>Buena luz y sin anillos en ese dedo</li></ul>'
        : '<ul class="cm-pr-hoja__consejos"><li>De frente y con buena luz</li><li>El cuello y el escote a la vista</li><li>Solo tú en la foto</li></ul>') +
      (error ? '<p class="cm-pr-hoja__error" role="alert">' + esc(error) + '</p>' : '') +
      '<div class="cm-pr-hoja__botones">' +
        '<button type="button" class="cm-pr-hoja__principal" data-camara-btn>' + (esAnillo ? 'Hacer una foto' : 'Hacer un selfie') + '</button>' +
        '<button type="button" class="cm-pr-hoja__secundario" data-galeria-btn>Elegir una foto</button>' +
      '</div>' +
      '<p class="cm-pr-hoja__legal">Usamos tu foto solo para crear esta imagen (con OpenAI) y no la guardamos. ' +
      '<a href="/policies/privacy-policy" target="_blank" rel="noopener">Privacidad</a>. La imagen la crea una IA y es orientativa' +
      (quedan !== null ? ' · Te quedan ' + quedan + ' prueba' + (quedan === 1 ? '' : 's') + ' hoy' : '') + '.</p>';
  }

  function pintarEspera(mini) {
    cuerpo.innerHTML =
      '<p class="cm-pr-hoja__etiqueta">Pruébatelo</p>' +
      '<div class="cm-pr-hoja__foto is-cargando"><img alt="" src="' + mini + '"><span class="cm-pr-hoja__brillo"></span></div>' +
      '<p class="cm-pr-hoja__estado" aria-live="polite"><span class="cm-pr-hoja__punto"></span><span data-msg>' + (esAnillo ? 'Poniéndote ' + laPieza + '…' : 'Poniéndote el colgante…') + '</span></p>' +
      '<div class="cm-pr-hoja__barra"><i></i></div>' +
      '<p class="cm-pr-hoja__legal">Tarda unos 25 segundos. Puedes cerrar esta ventana: te esperamos aquí.</p>';
    var msgs = [esAnillo ? 'Poniéndote ' + laPieza + '…' : 'Poniéndote el colgante…', 'Ajustándolo a su tamaño real…', 'Cuidando la luz y los reflejos…', 'Ya casi está…'], i = 0;
    var t = setInterval(function () {
      var el = cuerpo.querySelector('[data-msg]');
      if (!el) return clearInterval(t);
      i = Math.min(i + 1, msgs.length - 1); el.textContent = msgs[i];
    }, 7000);
  }

  function pintarResultado(src) {
    resultado = src;
    cuerpo.innerHTML =
      '<p class="cm-pr-hoja__etiqueta">' + (previos.length ? 'Así os quedan' : 'Así te queda') + '</p>' +
      previos.concat([src]).map(function (u) {
        return '<div class="cm-pr-hoja__foto" data-zoom><div class="cm-pr-hoja__marco"><img alt="Tu foto con la joya puesta" src="' + u + '"></div>' +
          '<span class="cm-pr-hoja__lupa">Toca para verlo de cerca</span></div>';
      }).join('') +
      '<div class="cm-pr-hoja__botones">' +
        '<button type="button" class="cm-pr-hoja__principal" data-personalizar>' + (esAnillo ? 'Elegir talla y grabado' : 'Personalizar el mío') + '</button>' +
        '<button type="button" class="cm-pr-hoja__secundario" data-compartir>Enviar por WhatsApp</button>' +
      '</div>' +
      (quedan > 0 ? '<button type="button" class="cm-pr-hoja__enlace" data-otra>' + (esAlianza && !previos.length ? 'Probar con la mano de tu pareja' : 'Probar con otra foto') + ' (te quedan ' + quedan + ')</button>' : '') +
      '<p class="cm-pr-hoja__legal">Imagen creada por IA, orientativa. ' + (esAnillo ? (esAlianza ? 'La alianza' : 'El anillo') + ' real mide ' + esc(medida) + '.' : raiz.dataset.medida ? 'La joya real mide ' + esc(medida) + '.' : 'El colgante real mide ' + mm + ' × ' + mm + ' mm.') +
      (modo === 'ejemplo' || modo === 'anillo-ejemplo' ? ' Si la joya lleva nombres o grabados personalizados, los de la foto son de ejemplo.' : '') + '</p>';
    if (!hoja.classList.contains('is-abierta')) marcarListo();
  }

  function leerFoto(f) {
    if (window.createImageBitmap) return createImageBitmap(f, { imageOrientation: 'from-image' }).catch(function () { return cargarImagen(URL.createObjectURL(f)); });
    return cargarImagen(URL.createObjectURL(f));
  }
  function cargarImagen(src) {
    return new Promise(function (ok, ko) { var im = new Image(); im.onload = function () { ok(im); }; im.onerror = ko; im.src = src; });
  }
  function lienzo(fuente, maxLado) {
    var k = Math.min(1, maxLado / Math.max(fuente.width, fuente.height)), c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(fuente.width * k)); c.height = Math.max(1, Math.round(fuente.height * k));
    c.getContext('2d').drawImage(fuente, 0, 0, c.width, c.height);
    return c;
  }

  // El nombre: el de la hoja si lo han escrito; si no, el del campo de la ficha. El color, el de la variante elegida.
  var nombreElegido = '';
  // Los campos del personalizador de la ficha (los visibles de [data-cm-fields]): etiqueta, el ejemplo (placeholder,
  // que es el texto de la foto) y lo que haya escrito la clienta. Sin personalizador: el campo de Text Box.
  function camposFicha() {
    var cm = [].filter.call(document.querySelectorAll('[data-cm-fields] input[type="text"], [data-cm-fields] textarea'), function (i) { return i.offsetParent; });
    if (cm.length) return cm.map(function (i, n) {
      var l = (i.id && document.querySelector('label[for="' + i.id + '"]')) || i.closest('label') || (i.parentElement && i.parentElement.querySelector('label')),
        t = l ? l.textContent.trim().split('\n')[0].trim() : '';
      return { etiqueta: (t && t.length < 50 ? t : 'Texto ' + (n + 1)), de: (i.placeholder || '').trim(), a: i.value.trim(),
        max: i.maxLength > 0 ? Math.min(i.maxLength, 24) : 24 };
    });
    // Text Box: un campo (input o textarea; el del quick-buy es una copia, se coge el visible)
    var tbs = [].slice.call(document.querySelectorAll('input[type="text"][name^="properties["]:not([name^="properties[_"]), textarea[name^="properties["]:not([name^="properties[_"])')),
      tb = tbs.filter(function (i) { return i.offsetParent; })[0] || tbs[0];
    return [{ etiqueta: tb ? tb.name.replace(/^properties\[|\]$/g, '') : 'Texto de la joya', de: '', a: tb ? tb.value.replace(/\s+/g, ' ').trim() : '', max: 40 }];
  }
  function nombreFicha() {
    var cm = [].filter.call(document.querySelectorAll('[data-cm-fields] input[type="text"]'), function (i) { return i.offsetParent && i.value.trim(); });
    if (cm.length) return cm[0].value.trim().slice(0, 14);
    var c = document.querySelector('form[id^="product-form-main"] input[type="text"][name^="properties["]:not([name^="properties[_"])')
      || document.querySelector('input[type="text"][name^="properties["]:not([name^="properties[_"])');
    return c ? c.value.trim().slice(0, 14) : '';
  }
  function colorFicha() {
    var v = [].map.call(document.querySelectorAll('variant-picker input:checked, variant-picker select'), function (i) { return i.value; }).join(' ');
    return /plateado|blanco/i.test(v) ? 'plateado' : 'dorado';
  }
  function procesar(f) {
    if (conNombre) {
      var campo = cuerpo.querySelector('[data-nombre-campo]');
      nombreElegido = (campo && campo.value.trim()) || nombreFicha();
      if (esInicial) nombreElegido = nombreElegido.slice(0, 1);
    }
    var textosElegidos = null;
    if (esTextos) {
      var cs = [].slice.call(cuerpo.querySelectorAll('[data-texto-campo]'));
      textosElegidos = cs.some(function (c) { return c.dataset.de; })
        ? cs.map(function (c) { return { de: c.dataset.de, a: c.value.trim() || c.dataset.de }; })
        : cs.map(function (c) { return c.value.trim(); }).filter(Boolean).join(' ');
    }
    var id = ++encargoVivo;
    leerFoto(f).then(function (bm) {
      var c = lienzo(bm, 1024);
      var jpg = c.toDataURL('image/jpeg', 0.86);
      pintarEspera(jpg);
      return fetch(API + '/probar', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ foto: jpg.split(',')[1], pieza: pieza, sesion: sesionId(), nombre: nombreElegido, color: colorFicha(), textos: textosElegidos }) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (r) {
          if (!r.ok) { evento('error', { motivo: r.d && r.d.error || 'http' }); return pintarInicio(r.d && r.d.mensaje || 'No hemos podido usar la foto. Inténtalo de nuevo.'); }
          quedan = r.d.quedan;
          evento('foto');
          esperar(r.d.encargo, 0, id);
        });
    }).catch(function () { pintarInicio('No hemos podido abrir esa foto o no hay conexión. Prueba otra vez.'); });
  }

  function esperar(encargo, intentos, id) {
    if (id !== encargoVivo) return;
    if (intentos > 120) return pintarInicio('Está tardando más de lo normal. Vuelve a intentarlo en un momento.');
    setTimeout(function () {
      fetch(API + '/estado?encargo=' + encodeURIComponent(encargo)).then(function (r) { return r.json(); }).then(function (d) {
        if (d.estado === 'trabajando' || d.estado === 'parcial') return esperar(encargo, intentos + 1, id);
        if (id !== encargoVivo) return;
        if (d.estado === 'error' || !d.probado) { evento('error', { motivo: d.aviso ? 'foto_rechazada' : 'servidor' }); return pintarInicio(d.aviso || d.mensaje || 'No hemos podido crear la imagen. Inténtalo de nuevo.'); }
        pintarResultado('data:image/jpeg;base64,' + d.probado);
        evento('resultado');
        marcarCesta();
      }).catch(function () { esperar(encargo, intentos + 2, id); });
    }, intentos === 0 ? 8000 : 1500);
  }

  // A tamaño real el colgante es pequeño en la foto entera: al tocarla se amplía (x2,5) centrada en el escote, donde
  // descansa, y se puede mover con el dedo. Otro toque la devuelve entera.
  function ampliar(z) {
    var lupa = z.querySelector('.cm-pr-hoja__lupa'), m = z.querySelector('.cm-pr-hoja__marco');
    if (z.classList.toggle('is-zoom')) {
      void m.offsetHeight;                     // fuerza la maqueta ampliada antes de medir
      m.scrollLeft = (m.scrollWidth - m.clientWidth) / 2;
      m.scrollTop = m.scrollHeight * 0.62 - m.clientHeight / 2;
      if (lupa) lupa.textContent = 'Toca para verla entera';
    } else if (lupa) lupa.textContent = 'Toca para verlo de cerca';
  }

  function irAPersonalizar() {
    evento('personalizar');
    cerrar();
    // scrollIntoView no se mueve mientras la hoja suelta el overflow de <html>: se baja a mano, con aire para la cabecera
    var paso = document.querySelector('[data-cm-step="2"]') || document.querySelector('[data-cm-personalizador]');
    if (paso) setTimeout(function () { window.scrollTo({ top: paso.getBoundingClientRect().top + window.scrollY - 90, behavior: 'smooth' }); }, 260);
  }

  function compartir() {
    if (!resultado) return;
    evento('compartir');
    var texto = 'Mira cómo me queda el ' + (raiz.dataset.titulo || 'colgante') + ' de Customima ' + location.origin + location.pathname;
    fetch(resultado).then(function (r) { return r.blob(); }).then(function (blob) {
      var archivo = new File([blob], 'customima-pruebatelo.jpg', { type: 'image/jpeg' });
      if (navigator.canShare && navigator.canShare({ files: [archivo] })) {
        return navigator.share({ files: [archivo], text: texto }).catch(function () {});
      }
      // Sin compartir con archivo (escritorio): se descarga la foto y se abre WhatsApp con el enlace.
      var a = document.createElement('a');
      a.href = resultado; a.download = 'customima-pruebatelo.jpg';
      document.body.appendChild(a); a.click(); a.remove();
      window.open('https://wa.me/?text=' + encodeURIComponent(texto), '_blank', 'noopener');
    });
  }
})();
